import { Loader2, Square, Sparkles } from "lucide-react";

const inp = "w-full px-4 rounded-xl bg-bg border border-line text-base text-ink placeholder:text-mute/70 focus:outline-none focus:border-[var(--q)] transition-colors";
const FIELDS = [
  ["tajuk", "Tajuk Program", "Contoh: Bengkel Kepimpinan Berasaskan Amanah", false],
  ["peserta", "Jenis Peserta", "Contoh: 25 penyelia barisan hadapan sebuah syarikat logistik", false],
  ["tempoh", "Tempoh Program", "Contoh: 1 hari (6 jam) atau 2 jam", false],
  ["cabaran", "Masalah / Cabaran Peserta", "Apa yang peserta hadapi sekarang?", true],
  ["objektif", "Objektif Program", "Apa yang peserta patut boleh lakukan selepas program?", true],
  ["ayat", "Ayat / Surah Rujukan (pilihan)", "Contoh: 4:58 atau Al-Hasyr 18. Biarkan kosong untuk dicadangkan", false],
];
export const EMPTY_PROGRAM = Object.fromEntries(FIELDS.map(([k]) => [k, ""]));
export const programValid = (f) => f.tajuk.trim().length >= 3 && f.peserta.trim().length >= 2 && f.tempoh.trim() && f.cabaran.trim().length >= 5 && f.objektif.trim().length >= 3;

export const ProgramForm = ({ form, setForm, loading, status, onSubmit, onCancel, parentTitle }) => (
  <form className="surface rounded-2xl p-5 sm:p-7 space-y-5" onSubmit={(e) => { e.preventDefault(); onSubmit(); }} data-testid="program-form">
    {parentTitle && <p className="text-sm rounded-xl bg-q-soft text-ink p-3" data-testid="program-parent-note">Versi baharu bagi <strong>{parentTitle}</strong>. Versi asal kekal dalam Ruang Kerja.</p>}
    <div className="grid sm:grid-cols-2 gap-4">
      {FIELDS.map(([k, label, ph, area]) => (
        <label key={k} className={`block ${area ? "sm:col-span-2" : ""}`}>
          <span className="eyebrow block mb-2">{label}</span>
          {area ? <textarea rows={3} value={form[k]} onChange={(e) => setForm({ ...form, [k]: e.target.value })} placeholder={ph} data-testid={`program-${k}-input`} className={`${inp} py-3 resize-y`} />
            : <input value={form[k]} onChange={(e) => setForm({ ...form, [k]: e.target.value })} placeholder={ph} data-testid={`program-${k}-input`} className={`${inp} h-12`} />}
        </label>
      ))}
      {form.penambahbaikan !== undefined && (
        <label className="block sm:col-span-2">
          <span className="eyebrow block mb-2">Penambahbaikan daripada AAR</span>
          <textarea rows={3} value={form.penambahbaikan} onChange={(e) => setForm({ ...form, penambahbaikan: e.target.value })} data-testid="program-penambahbaikan-input" className={`${inp} py-3 resize-y`} />
        </label>
      )}
    </div>
    <div className="flex flex-wrap items-center justify-between gap-3">
      <p className="text-xs text-mute max-w-md" data-testid="program-quota-notice">Membina kerangka program menggunakan <strong className="text-ink">1 kuota carian</strong>. Mencari calon ayat, melihat, menyunting, menyalin dan mencatat AAR adalah percuma.</p>
      {loading ? (
        <button type="button" onClick={onCancel} data-testid="program-cancel-button" className="h-12 px-6 rounded-full border border-line inline-flex items-center gap-2"><Square size={14} /> Henti</button>
      ) : (
        <button type="submit" disabled={!programValid(form)} data-testid="program-build-button"
          className="h-12 px-7 rounded-full bg-ink text-bg font-semibold inline-flex items-center gap-2 disabled:opacity-40 hover:opacity-90 transition-opacity">
          <Sparkles size={16} /> {form.ayat.trim() ? "Bina Kerangka Program" : "Cari Ayat Yang Sesuai"}
        </button>
      )}
    </div>
    {loading && status && <div className="flex items-center gap-3 text-sm text-mute" data-testid="program-status" aria-live="polite"><Loader2 size={16} className="animate-spin text-q" /> {status}</div>}
  </form>
);
